import {createAction} from 'redux-actions';
import {batchActions} from 'redux-batched-actions';
import i18n from "../../../../i18n";
import authService from "../../domain/services/AuthService";
import {AuthProviderEnum} from '../../domain/enums/AuthProvidersEnum';
import {setProcessingLoaderVisibility, setStarterLoaderVisibility} from "../../../layout/store/actions";
import {currentUserSelector} from "./selectors";
import {createLlamaStateSelector} from "../../../stickers/store/create-llama/selectors";
import {validateStickerAndSave} from "../../../stickers/store/create-llama/actions";
import {facebookSignInFailed} from '../auth-by-facebook/actions';
import {googleSignInFailed} from '../auth-by-google/actions';
import {push, replace} from "connected-react-router";
import {currentLocationSelector} from "../../../navigation/store/selectors";
import {stickerShowStateSelector} from "../../../stickers/store/sticker-show/selectors";
import {setAttachingStickerAfterLogin} from "../../../stickers/store/sticker-show/actions";

const namespace = 'AUTH_USER';

export const sessionLoadRequest = createAction(`${namespace}/SESSION_LOAD_REQUEST`);
export const sessionLoadSuccess = createAction(`${namespace}/SESSION_LOAD_SUCCESS`);
export const sessionLoadFailed = createAction(`${namespace}/SESSION_LOAD_FAILED`);
export const setCurrentUserInfo = createAction(`${namespace}/SET_CURRENT_USER_INFO`);

export const emailVerificationRequest = createAction(`${namespace}/EMAIL_VERIFICATION_REQUEST`);
export const emailVerificationSuccess = createAction(`${namespace}/EMAIL_VERIFICATION_SUCCESS`);
export const emailVerificationFailed = createAction(`${namespace}/EMAIL_VERIFICATION_FAILED`);

let checkAuthUnsubscribe = null;

export function checkAuthState() {
    return (dispatch, getState) => {

        dispatch(batchActions([
            setStarterLoaderVisibility(true),
            sessionLoadRequest()
        ]));

        handleRedirectResult(dispatch);

        checkAuthUnsubscribe = authService.onAuthStateChanged(state => {
            if (state) {
                if (state.info && state.info.lang) {
                    localStorage && localStorage.setItem('lang', state.info.lang);
                    i18n.changeLanguage(state.info.lang);
                }

                if (state.isNew) {
                    state.user.isNew = state.isNew;
                    dispatch(sendVerificationEmail());
                }

                const stickerForAttachFromStorage = localStorage.getItem('stikerForAttach');
                const stickerForContinue = localStorage.getItem('stickerForContinue');
                localStorage.removeItem('stickerForContinue');
                const isLoginProcess = localStorage.getItem('isLoginProcess');
                const {createStickerAfterSignIn} = createLlamaStateSelector(getState());
                let {stickerForAttach} = stickerShowStateSelector(getState());
                if (!stickerForAttach && stickerForAttachFromStorage) {
                    stickerForAttach = JSON.parse(stickerForAttachFromStorage);
                    dispatch(setAttachingStickerAfterLogin(stickerForAttach));
                }

                const commonSuccessActions = [
                    sessionLoadSuccess(state),
                    setStarterLoaderVisibility(false),
                    setProcessingLoaderVisibility(false),
                ];

                // If Sign in for Attaching sticker
                if (stickerForAttach && stickerForAttach.id != null) {
                    dispatch(batchActions(commonSuccessActions));
                    dispatch(push(`/stickers/${stickerForAttach.id}`));
                    localStorage.removeItem('stikerForAttach');
                } else if (createStickerAfterSignIn) {
                    // If Sign in for Create sticker
                    dispatch(batchActions([...commonSuccessActions, validateStickerAndSave()]));
                } else if (isLoginProcess) {
                    if (stickerForContinue) {
                        dispatch(batchActions([...commonSuccessActions, push(`/stickers/${stickerForContinue}`)]));
                    }
                    localStorage.removeItem('isLoginProcess');
                    dispatch(batchActions([...commonSuccessActions, push('/')]));
                } else {
                    const currentLocation = currentLocationSelector(getState());
                    let stickerId;
                    if (localStorage) {
                        stickerId = localStorage.getItem('confStickerId');
                        localStorage.setItem('confStickerId', '');
                    }
                    const authLocations = ['/login/email', '/register', '/login', '/login/email/forgot', '/profile-info'];
                    if (authLocations.includes(currentLocation)) {
                        dispatch(batchActions(commonSuccessActions));
                        if (state.isNew) {
                            dispatch(replace('/profile-info'));
                            if (stickerId) {
                                localStorage.setItem('confStickerId', stickerId)
                            }
                        } else if (stickerId) {
                            window.location.href = `${window.location.origin}/${stickerId}`;
                        } else {
                            dispatch(replace('/'));
                        }
                    } else {
                        dispatch(batchActions(commonSuccessActions));
                    }
                }
            } else {
                const defaultLang = i18n.dir() === 'rtl' ? 'he' : 'en';
                localStorage && localStorage.setItem('lang', defaultLang);

                dispatch(batchActions([
                    sessionLoadFailed(state),
                    setStarterLoaderVisibility(false),
                    setProcessingLoaderVisibility(false),
                ]));
            }
        });
    };
}

export function stopCheckAuthState() {
    return (dispatch, getState) => {
        if (checkAuthUnsubscribe != null) {
            (checkAuthUnsubscribe as any)();
        }
    };
}

export function logout() {
    return (dispatch, getState) => {
        const user = currentUserSelector(getState());

        if (user) {
            dispatch(setStarterLoaderVisibility(true));
            authService.logout()
                .then(() => dispatch(setStarterLoaderVisibility(true)))
                .catch(() => dispatch(setStarterLoaderVisibility(true)));
        }
    };
}

export function sendVerificationEmail() {
    return (dispatch, getState) => {
        dispatch(emailVerificationRequest());

        authService.sendEmailVerification()
            .then((response) => {
                dispatch(emailVerificationSuccess());
            })
            .catch((error) => {
                dispatch(emailVerificationFailed(error));
            });
    };
}

function handleRedirectResult(dispatch) {
    authService.getRedirectResult()
        .catch((error) => {
            if (error.credential.providerId === AuthProviderEnum.facebook) {
                dispatch(facebookSignInFailed(error));
            } else if (error.credential.providerId === AuthProviderEnum.google) {
                dispatch(googleSignInFailed(error));
            }
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/store/auth-user/actions.ts